<template>
  <el-select :disabled="disabled" v-model="val" value-key="code" :placeholder="placeholder" class="f-w" filterable
    :filter-method="filterData" @change="change" default-first-option :clearable="clearable" size="small">
    <el-option v-for="item in options" :key="item.code" :label="item.text" :value="item.code" />
  </el-select>
</template>

<script>
import {
  mapGetters
} from "vuex";
export default {
  props: {
    value: String,
    dictType: String,
    dictObj: Object,
    isEnum: Boolean,
    autoFirst: Boolean,
    filterCodes: Array,
    disabled: Boolean,
    isMed: Boolean,
    clearable: { type: Boolean, default: true },
    placeholder: { type: String, default: '请选择' }
    // ifOp: { type: Boolean, default: true },
    // ifIpt: { type: Boolean, default: false },
    // ifReg: { type: Boolean, default: true },
    // ifOpSep: { type: Boolean, default: false },
  },
  data () {
    return {
      val: this.value,
      options: []
    }
  },
  computed: {
    ...mapGetters(["dict", "dictEnum", "medDict"]),
    dictOptions () {
      let options = this.dict[this.dictType]
      if (this.isEnum) {
        options = this.dictEnum[this.dictType]
      }
      if (this.isMed) {
        options = this.medDict[this.dictType]
        // options = []
        // const items = this.medDict[this.dictType]
        // if (this.ifOp) {
        //   options.push(...items.filter(t => t.ifOp))
        // }
        // if (this.ifReg) {
        //   options.push(...items.filter(t => t.ifReg))
        // }
        // if (this.ifIpt) {
        //   options.push(...items.filter(t => t.ifIpt))
        // }
        // if (this.ifOpSep) {
        //   options.push(...items.filter(t => t.ifOpSep))
        // }
      }
      if (this.filterCodes && this.filterCodes.length) {
        return options.filter(op => {
          return this.filterCodes.findIndex(c => c == op.code) > -1
        })
      } else {
        return options
      }
    }
  },
  watch: {
    value () {
      this.val = this.value
      this.auto()
    },
  },
  mounted () {
    this.options = this.dictOptions
    this.auto()
  },
  methods: {
    change (code) {
      let dict = this.dictOptions.find(item => item.code == code)
      this.$emit('input', code)
      this.$emit('update:dictObj', dict)
      this.$emit('update:value', code)
      this.$emit('update:text', dict?.text)
      this.$emit('change', code, dict)
    },
    filterData (key) {
      if (!key) {
        this.options = this.dictOptions
      } else {
        this.options = this.dictOptions.filter(item => item.text.indexOf(key) > -1 || item.code.indexOf(key) > -1 || (item.shortCode && item.shortCode.indexOf(key) > -1))
      }
    },
    auto () {
      // 证件类型，默认为居民身份证
      if (!this.autoFirst && !this.value && this.dictType === 'IdType') {
        this.$emit('input', 'SF')
      }
      if (this.autoFirst && !this.value && this.dictOptions && this.dictOptions.length) {
        this.$emit('input', this.dictOptions[0].code)
      }
    }
  }
}
</script>
